module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/001-688e50552dde2c397ba37d1455c0d32b.jpg";